import { CloseIcon, SearchIcon } from "components/Icons";
import Spinner from "components/Spinner";

import styles from "./DirectorySearchPanel.module.scss";

interface Props {
  onSearch: (search: string) => void;
  search: string;
  controls?: React.ReactNode;
  isLoading?: boolean;
  disabled?: boolean;
  testId?: string;
}

const DirectorySearchPanel = (props: Props) => {
  const { onSearch, search, controls, isLoading, disabled, testId } = props;
  const handleClear = () => {
    if (disabled) {
      return;
    }
    onSearch("");
  };
  return (
    <div className={styles.directorySearchPanel}>
      <div className={styles.searchInputWrapper}>
        <input
          data-testid={testId}
          type="text"
          value={search}
          onChange={e => onSearch(e.target.value)}
          placeholder="Search"
          disabled={disabled}
        />
        <div className={styles.innerControls}>
          {controls ? (
            <div className={styles.innerControl}>{controls}</div>
          ) : null}
          {isLoading ? (
            <div className={styles.loadingSpinner}>
              <Spinner size={14} />
            </div>
          ) : null}
          <div
            className={styles.innerControl}
            onClick={handleClear}
          >
            {search ? <CloseIcon /> : <SearchIcon />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DirectorySearchPanel;
